import React from "react";
import {Calendar, Cast, Cpu, Filter, GitCommit, Loader, Mail, Send, ThumbsUp,} from "react-feather";
import img_lances from "../../imagens/mob_lances.png";
import {CollCard, CollImg, ContainerBody, Wrapper, WrapperContato} from "../styleMobile";
import {CardFeatures} from "../Components/CardFeatures";
import {CardHearder} from "../Components/CardHearde";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ContactForm from "../../Contato/ContactForm";
import {Formulario} from "./Formulario";
import styled from "styled-components";
import {Mensagem} from "./Mensagem";


export const CollHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 20%; 
  color: black;
  span{
    margin-top: 10px;
    font-size: 0.8rem;
    color: white;    
  }
  h2{
     color: #164a60;  
     font-size: 6vw;
     margin: 0;
   }
`;

export const CollForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 70%; 
  background: white;
  border-radius: 5px;
  padding: 20px 10px 10px 10px;
  justify-content: center;
`;

export const Contato = ({id}) => {
    return (
        <ContainerBody id={id} background={'#D0D0D0'}>
            <WrapperContato>

                <CollHeader>
                    <div><Mail size={'40px'}/></div>
                    <span>FORMULÁRIO</span>
                    <h2>CONTATO</h2>
                </CollHeader>
                <CollForm>
                    <Formulario/>
                </CollForm>
            </WrapperContato>
        </ContainerBody>
    )
};
